import { Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import { CHECK_EMAIL_INBOX_MESSAGE, CLOSE } from 'constants/languageConstants';
import { setEmployeeModal } from 'modules/auth/slices/employeeAuthSlice';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import styles from './sendEmail.module.less';

const SendEmail = () => {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.benguide.data?.language);
  return (
    <Row justify="center">
      <div>
        <h1 className={styles.textWrapper}>
          {getText(CHECK_EMAIL_INBOX_MESSAGE, language)}
        </h1>
        <SubmitButton
          type="primary"
          onClick={() => {
            dispatch(setEmployeeModal(false));
          }}
          htmlType="button"
          className={styles.submitPwdButton}
        >
          {getText(CLOSE, language)}
        </SubmitButton>
      </div>
    </Row>
  );
};

export default SendEmail;
